import moment from "moment";

export type FreshBatchStatus = "active" | "historic" | "future" | "canceled" | "exception";

export interface FreshBatchStatusInput {
  plantDate?: number | null;
  harvestDate?: number | null;
  canceled?: boolean;
  exception?: boolean;
}

/**
 * A fresh batch is:
 * - "canceled" when it has been explicitly canceled (all trays gone / failed)
 * - "exception" when something happened to the batch (e.g. some trays thrown away)
 * - "future" when the plant date is in the future
 * - "historic" when the harvest date is more than one week ago
 * - "active" otherwise (currently running or recently finished)
 */
export const getFreshBatchStatus = (input: FreshBatchStatusInput): FreshBatchStatus => {
  if (input.canceled) return "canceled";
  if (input.exception) return "exception";
  if (input.plantDate && moment(input.plantDate).isAfter(moment(), "day")) return "future";
  if (input.harvestDate && moment(input.harvestDate).isBefore(moment().subtract(1, "week"))) return "historic";
  return "active";
};

export const freshBatchStatusLabel: Record<FreshBatchStatus, string> = {
  active: "Aktiva",
  historic: "Historiska",
  future: "Framtida",
  canceled: "Avbrutna",
  exception: "Avvikelser",
};